import React from 'react';
import { SvgIcon } from '../../../../../../../common/react/components/SvgIcon';
import { BENCHMARKING } from '../config/benchmarking';

export const BenchmarkingLegend = () => (
    <div className="stats-leaders-benchmarking-legend">
        <span className="stats-leaders-benchmarking-legend__key stats-leaders-benchmarking-legend__key--elite">
            <SvgIcon
                icon="benchmarking-elite"
                className="stats-leaders-benchmarking-legend__icon"
            />
            { BENCHMARKING.ELITE.TEXT }
        </span>
        <span className="stats-leaders-benchmarking-legend__key stats-leaders-benchmarking-legend__key--above-average">
            <SvgIcon
                icon="benchmarking-above-average"
                className="stats-leaders-benchmarking-legend__icon"
            />
            { BENCHMARKING.ABOVE_AVERAGE.TEXT }
        </span>
        <span className="stats-leaders-benchmarking-legend__key stats-leaders-benchmarking-legend__key--average">
            <SvgIcon
                icon="benchmarking-average"
                className="stats-leaders-benchmarking-legend__icon"
            />
            { BENCHMARKING.AVERAGE.TEXT }
        </span>
        <span className="stats-leaders-benchmarking-legend__key stats-leaders-benchmarking-legend__key--below-average">
            <SvgIcon
                icon="benchmarking-below-average"
                className="stats-leaders-benchmarking-legend__icon"
            />
            { BENCHMARKING.BELOW_AVERAGE.TEXT }
        </span>
    </div>
);